<template>
  <div
    class="w-full flex flex-col items-left mr-4 mb-4 rounded border p-2"
    :class="{
      'border-primary': this.activeOption === option.id,
      'border-grey-200': this.activeOption !== option.id,
    }"
    @click="updateActiveOption"
    @keydown.space="updateActiveOption"
  >
    <label
      class="flex cursor-pointer"
      :class="{
        'cursor-not-allowed': option.coming_soon || option.sms_not_allowed,
        'cursor-pointer': !(option.coming_soon || option.sms_not_allowed),
      }"
    >
      <span
        class="w-6 h-5 inline-block mr-1 mt-1 rounded-full border"
        :class="{
          'border-grey bg-primary text-primary activeOptionRadio':
            this.activeOption === option.id,
          'border-grey':
            this.activeOption !== option.id &&
            !(option.coming_soon || option.sms_not_allowed),
          'border-grey-200': option.coming_soon || option.sms_not_allowed,
        }"
      ></span>
      <div class="ml-2 flex flex-col w-full">
        <label
          class="font-semibold"
          :class="{
            'text-primary': this.activeOption === option.id,
            'text-grey-700':
              this.activeOption !== option.id &&
              !(option.coming_soon || option.sms_not_allowed),
            'text-grey-300': option.coming_soon || option.sms_not_allowed,
          }"
        >
          {{ option.title }}
          <div v-if="option.coming_soon" class="text-xs">
            (
              {{ 
                option.disabled_message
                  ? option.disabled_message
                  : $t('frontend_groovemail_components_custom_radio_coming')
              }}
            )
          </div>
          <div v-else-if="option.sms_not_allowed" class="text-xs">
            (
            {{ $t('frontend_groovemail_custom_radio_sms_not_allowed_warning') }}
            )
          </div>
        </label>
        <div class="text-grey-500">
          {{ option.description }}
        </div>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: 'GdCustomRadio',
  model: {
    prop: 'activeOption',
    event: 'onUpdateOption',
  },
  props: ['option', 'activeOption'],
  methods: {
    updateActiveOption() {
      if (!(this.option.coming_soon || this.option.sms_not_allowed)) {
        this.$emit('onUpdateOption', this.option.id);
      }
    },
  },
};
</script>

<style>
.activeOptionRadio {
  box-shadow: 0px 0px 0px 2px white inset;
}
</style>
